import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthService } from '@core/services/auth.service';
import { CredentialsService } from '@core/services/credentials.service';
import { Router } from '@angular/router';
import { AlertService } from '@app/@core/services/alert.service';

@Component({
  selector: 'app-sso-callback',
  templateUrl: './sso-callback.component.html',
  styleUrl: './sso-callback.component.css',
  standalone: false,
})
export class SsoCallbackComponent implements OnInit {
  constructor(
    private readonly oidcService: OidcSecurityService,
    private readonly authService: AuthService,
    private readonly credentialsService: CredentialsService,
    private readonly router: Router,
    private readonly alert: AlertService
  ) {}

  ngOnInit(): void {
    this.oidcService.checkAuth().subscribe({
      next: ({ isAuthenticated, idToken, userData }) => {
        if (isAuthenticated) {
          this.credentialsService.setCredentials(idToken);

          const authResultSubscription = this.oidcService.getAuthenticationResult().subscribe((authResult) => {
          sessionStorage.setItem('refreshToken', authResult?.refresh_token ?? '');
        //  sessionStorage.setItem('id', res['data'].idToken.payload['custom:id']);
             return authResult;
          });
          console.log('Authentication result subscription:', authResultSubscription);
          sessionStorage.setItem('email', userData?.email ?? '');
          sessionStorage.setItem('username',userData?.name ?? userData?.email ?? ''
          );
          sessionStorage.setItem('isSSO', 'yes');

          /* SSO Login lod added */
          const loginUserData = {
            userid : userData?.email ?? '',
            source_login: 'Web'
          }
          this.authService.addUserLoginLog(loginUserData).subscribe();

          this.authService.ssoLoginInfo(userData, userData?.email ?? '').subscribe();
          this.authService.getLoggedInUserInfo(true);
        } else {
          this.router.navigate(['/auth/login']);
        }
      },
      error: () => {
        this.alert.error("You should not have an enough permission to login into COMET, Please contact Administrator.");
        this.router.navigate(['/auth/login']);
      },
    });
  }
}
